import React, { createContext, ReactElement } from 'react';

export interface AppConfigContextValue {
  isZigzagApp: boolean;
  zigzagUuid: string | null;
  /**
   * Croquis-Client-Navigation 문서 링크
   * https://www.notion.so/croquis/1ff3dd4dd5b18023b286fc18a31f6ae0?v=2003dd4dd5b18076a61d000c13e5352a&pvs=4
   */
  croquisClientNavigation: string | null;
}

const defaultValue: AppConfigContextValue = {
  isZigzagApp: false,
  zigzagUuid: null,
  croquisClientNavigation: null,
};

const AppConfigContext = createContext<AppConfigContextValue>(defaultValue);

export interface AppConfigProviderProps extends Partial<AppConfigContextValue> {
  children: ReactElement;
}

export const AppConfigProvider = (props: AppConfigProviderProps) => {
  const {
    isZigzagApp = defaultValue.isZigzagApp,
    zigzagUuid = defaultValue.zigzagUuid,
    croquisClientNavigation = defaultValue.croquisClientNavigation,
    children,
  } = props;

  return (
    <AppConfigContext.Provider value={{ isZigzagApp, zigzagUuid, croquisClientNavigation }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export function useAppConfig() {
  return React.useContext(AppConfigContext);
}
